const config = {
  works: [
    {
      title: 'Send',
      desc: 'Pack your boxes and ship them to our warehouse.',
      icon: require('../../assets/imgs/home-works_order.png'),
      count: 1,
      bcolor: '#FFFFFF',
    },
    {
      title: 'Storage',
      desc: "We'll store your boxes for 1 cent per pound per day.",
      icon: require('../../assets/imgs/home-works_send.png'),
      count: 2,
      bcolor: '#FFFFFF',
    },
    {
      title: 'Return',
      desc: "When you're ready to move, we'll forward them to your destination on date.",
      icon: require('../../assets/imgs/home-works_storage.png'),
      count: 3,
      bcolor: '#FFFFFF',
    },
  ],
  whats: [
    {
      title: 'Graduate Travel',
      desc:
        'Graduation can be overwhelming with all your \n' +
        "belongings to move. Whether you're planning \n" +
        'to travel or declutter your apartment',
    },
    {
      title: 'Summer Break',
      desc:
        'Every student dreads this moment: clearing out \n' +
        'your dorm before summer break. Store your items \n' +
        'briefly to avoid shipping everything home',
    },
    {
      title: 'Relocation',
      desc:
        "Whether you're a recent grad or relocating for work, \n" +
        'we understand the apartment search can be tough. \n' +
        "Store your stuff until you're settled",
    },
    {
      title: 'Tradeshow',
      desc:
        "Store your company's tradeshow materials in advance\n" +
        'so that it can be easily and faster accessed whenever\n' +
        'needed.',
    },
  ],
  delights: [
    {
      title: 'Discounted Shipping Rates',
      desc: 'MovingKite offers lower shipping rates than FedEx retail rates',
    },
    {
      title: 'Lower daily rates',
      desc: "At only a penny a pound a day! Don't worry about your long-term journey",
    },
    {
      title: 'Door-to-Door Service',
      desc: 'Pick up from your door, storage and forward them to your door',
    },
  ],
  planCards: [
    {
      icon: require('../../assets/imgs/home-form-car.png'),
      title: 'Pick up',
      desc: 'Learn more about FedEx pick up',
      charge: '$13/time',
    },
    {
      icon: require('../../assets/imgs/home-form-house.png'),
      title: 'Drop off',
      desc: 'Find FedEx locations nearby',
      charge: 'Free',
    },
  ],
};

export default config;
